export const DASH_BREAKPOINTS = {
    smDesktop: 1360,
    desktop: 1600,
    large: 1920,
    twoK: 2560,
    fourK: 3440
};

export const fluidPx = (min, max, vw, minVw = DASH_BREAKPOINTS.smDesktop, maxVw = DASH_BREAKPOINTS.fourK) => {
    const t = Math.max(0, Math.min(1, (vw - minVw) / (maxVw - minVw)));
    return Math.round(min + (max - min) * t);
};

export const scalePx = (size, refPx, refSize, min, max) =>
    Math.max(min, Math.min(max, Math.round((refPx * size) / refSize)));
